/* eslint-disable max-lines */ //TODO refactor max lines
import { Directive, ElementRef, HostListener } from '@angular/core';
import { TabOrderFocusSuperDirective } from './tab-order-focus-super.directive';

@Directive({
  selector: '[idpTabOrderFocus]',
  standalone: true
})
export class TabOrderFocusDirective extends TabOrderFocusSuperDirective {
  constructor(private el: ElementRef) {
    super();
  }

  private handlePrimaryNav(event: KeyboardEvent, target: HTMLElement): boolean {
    if (!this.isPrimaryNav(target)) return false;
    const next =
      document.querySelector<HTMLElement>(
        '#mach-core-widget-tabs-section [role="tab"][aria-selected="true"]'
      ) ??
      this.firstVisible(document.querySelector('#mach-core-header-widgets'));
    this.focusEl(event, next);
    return true;
  }

  private handleFlightsTab(event: KeyboardEvent): void {
    const btns = [
      '#one-way-route-picker-origin-button',
      '#one-way-route-picker-destination-button',
      '#one-way-route-picker-swap-button'
    ].map((s) => document.querySelector<HTMLElement>(s));
    btns.forEach((btn) => btn?.setAttribute('tabindex', '0'));
    document.querySelector('#findFilghtsCta')?.setAttribute('tabindex', '-1');
    this.focusEl(event, btns[0]);
  }

  private handleBookingTab(event: KeyboardEvent, target: HTMLElement): boolean {
    if (!this.isBookingTab(target)) return false;
    if (target.id === 'flights') this.handleFlightsTab(event);
    else
      this.focusEl(
        event,
        this.firstVisible(
          document.querySelector(`#mach-core-header-widgets #${target.id}`)
        )
      );
    return true;
  }

  private handleMyTripsLastInput(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (
      target.tagName !== 'INPUT' ||
      !target.closest('#mach-core-trip-search-content')
    )
      return false;
    const hotelLink = this.getHotelLinkIfLastInput(target);
    if (hotelLink) {
      document
        .querySelector('#mach-core-trip-search-submit')
        ?.setAttribute('tabindex', '-1');
      this.focusEl(event, hotelLink);
    }
    return true;
  }

  private handleMyTripsCarLink(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (target.id !== 'mach-core-ancillary-car-link') return false;
    const submit = document.querySelector<HTMLElement>(
      '#mach-core-trip-search-submit'
    );
    if (submit) {
      submit.setAttribute('tabindex', '0');
      this.focusEl(event, submit);
    }
    return true;
  }

  private handlePassengerDropdown(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (
      target.getAttribute('role') !== 'combobox' ||
      !target.classList.contains('custom_dropdown_list_width')
    )
      return false;
    this.focusEl(event, document.querySelector<HTMLElement>('#shopWithMiles'));
    return true;
  }

  private handleFindFlightsCta(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (target.id !== 'findFilghtsCta') return false;
    this.focusEl(event, this.focusTopBar());
    return true;
  }

  private handleAdvancedSearchToggle(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (!this.isAdvancedSearchToggle(target)) return false;
    if (this.isAdvancedSearchCollapsed()) this.focusFindFlights(event);
    return true;
  }

  private handleEdocsLink(event: KeyboardEvent, target: HTMLElement): boolean {
    if (
      !target.classList.contains('link-md') ||
      !target.closest('.home-book-widget-desktop')
    )
      return false;
    this.focusFindFlights(event);
    return true;
  }

  private handleSecondaryNavDropdown(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (!target.closest('#mach-core-secondary-nav-pages')) return false;
    const links = Array.from(
      document.querySelectorAll<HTMLElement>(
        '#mach-core-secondary-nav-pages a[href]'
      )
    ).filter((el) => el.offsetParent !== null);
    if (links[links.length - 1] === target)
      this.focusEl(event, this.focusTopBar());
    return true;
  }

  private isWidgetSubmit(target: HTMLElement): boolean {
    if (target.id === 'findFilghtsCta') return false;
    return (
      this.isKnownSubmitId(target) || this.isButtonPrimaryInWidgets(target)
    );
  }

  private handleWidgetSubmit(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (!this.isWidgetSubmit(target)) return false;
    this.focusEl(event, this.focusTopBar());
    return true;
  }

  private handleSearchButton(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (target.id !== 'mach-core-header-search-button') return false;
    const amex = document.querySelector<HTMLElement>(
      '#mach-core-widget-delta-amex-link'
    );
    if (amex) this.focusEl(event, amex);
    else this.focusAfterHeader(event);
    return true;
  }

  private handleBagsLink(event: KeyboardEvent, target: HTMLElement): boolean {
    if (target.id !== 'mach-core-widget-update-bag-travel-link') return false;
    this.focusAfterHeader(event);
    return true;
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Tab') return;
    const target = event.target as HTMLElement;
    const handlers = event.shiftKey
      ? [
          this.shiftHandleRoutePickerBtn,
          this.shiftHandleBookingTab,
          this.shiftHandleFirstWidgetField,
          this.shiftHandleShopWithMiles,
          this.shiftHandleFindFlights,
          this.shiftHandleAmexLink
        ]
      : [
          this.handlePrimaryNav,
          this.handleBookingTab,
          this.handleMyTripsLastInput,
          this.handleMyTripsCarLink,
          this.handlePassengerDropdown,
          this.handleFindFlightsCta,
          this.handleAdvancedSearchToggle,
          this.handleEdocsLink,
          this.handleSecondaryNavDropdown,
          this.handleWidgetSubmit,
          this.handleSearchButton,
          this.handleBagsLink
        ];
    handlers.some((handler) => handler.call(this, event, target));
  }
}
